var React = require('react');

function RemovePlain (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"square"},React.createElement("g",{"id":"Group","transform":"translate(2 2)","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"d":"M10.607 0L0 10.607","id":"Line","key":0}),React.createElement("path",{"d":"M10.607 10.607L0 0","id":"Line-Copy","key":1})])));
}

RemovePlain.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = RemovePlain;

RemovePlain.default = RemovePlain;
